import { Box, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Controller } from "react-hook-form"

import {
  ImgWrapper,
  InputWrapper,
  Label,
  OrderNumber,
  ProductContainer,
  ProductImg,
  ProductTitle,
  Text,
} from "areas/order/components"
import FloatSelect from "components/ui/float-select"
import { filterProductOptions } from "helpers/product/product-filtering"

const ChooseSize = ({ control, item, orderData, setValue }) => (
  <>
    <Typography fontSize="18px" fontWeight="500" lineHeight="20px">
      Your Order Number:
    </Typography>
    <OrderNumber>{orderData.order.number}</OrderNumber>
    <Flex flexDirection="column">
      <Controller
        control={control}
        name="rma_id"
        render={({ field, fieldState: { error } }) => (
          <>
            <Label htmlFor="rma_id">
              Please select the item(s) you would like to resize/exchange:
            </Label>
            <InputWrapper>
              <FloatSelect
                {...field}
                error={error}
                id="rma_id"
                label="Select an item"
                onChange={(e) => {
                  setValue("rma_id", e.target.value)
                  setValue("new_ring_size", "")
                }}
              >
                <option disabled value="">
                  Select an item
                </option>
                {orderData.order.line_items.map((li) => (
                  <option key={`lineitems${li.id}`} value={li.id}>
                    {li.title}
                  </option>
                ))}
              </FloatSelect>
            </InputWrapper>
          </>
        )}
      />
    </Flex>
    {item && (
      <ProductContainer>
        <ImgWrapper>
          <ProductImg alt={item.title} src={item.image_url} />
        </ImgWrapper>
        <Box>
          <ProductTitle>{item.title}</ProductTitle>
          {!item.has_in_progress_rma && (
            <>
              <Text mt={3}>
                <strong>Original Shipment Date:</strong>{" "}
                {item.original_ship_date}
              </Text>
              <Text mb={4}>
                <strong>Original Ring Size:</strong>{" "}
                {item.resize_info.original_ring_size}
              </Text>
            </>
          )}
        </Box>
      </ProductContainer>
    )}
    {!item ? null : item.has_in_progress_rma ? (
      <>
        <Text color="error" fontWeight="500">
          Your item has an RMA (Return Merchandise Authorization) already in
          progress.
        </Text>
        <Text fontWeight="500">
          Please contact customer service at{" "}
          <Typography
            as="a"
            href={`tel:${sl.config.customer_service_toll_free}`}
          >
            {sl.config.customer_service_toll_free}
          </Typography>{" "}
          or{" "}
          <Typography
            as="a"
            href={`mailto:${sl.config.customer_service_email}`}
          >
            {sl.config.customer_service_email}
          </Typography>{" "}
          for assistance.
        </Text>
      </>
    ) : (
      <>
        {item?.is_resizable_for_free && (
          <Box mb={2}>
            <Text>
              We are happy to offer resizing on most of our rings within two
              full sizes.{" "}
            </Text>
            <Text>
              Resizing more than two full sizes is available for a fee.
            </Text>
          </Box>
        )}
        <Controller
          control={control}
          name="new_ring_size"
          render={({ field, fieldState: { error } }) => (
            <>
              <Label htmlFor="new_ring_size">
                Please select your new ring size:
              </Label>
              <InputWrapper>
                <FloatSelect
                  error={error}
                  id="new_ring_size"
                  label="Select new size"
                  {...field}
                >
                  <option disabled value="">
                    Select new size
                  </option>
                  {item.resize_info.size_options &&
                    filterProductOptions(
                      item.resize_info.size_options,
                      { pref: "sku", value: item.resize_info.sku },
                      true
                    ).map((size, i) => (
                      <option
                        hidden={
                          size.display_name ===
                          item.resize_info.original_ring_size
                        }
                        key={`itemsizes${i}`}
                        value={size.value}
                      >
                        {`${size.display_name} ${
                          size.price != 0 ? `(+${size.fees.price})` : ""
                        }`}
                      </option>
                    ))}
                </FloatSelect>
              </InputWrapper>
            </>
          )}
        />
      </>
    )}
  </>
)

ChooseSize.propTypes = {
  control: PropTypes.object,
  item: PropTypes.object,
  orderData: PropTypes.object,
  setValue: PropTypes.func,
}

export default ChooseSize
